import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaskDirective } from './mask.directive';
import { ResendOtpDirective } from './resend-otp.directive';

@NgModule({
  declarations: [
    MaskDirective,
    ResendOtpDirective,

  ],
  imports: [CommonModule],
  exports: [
    MaskDirective,

  ],
  providers: [],
})
export class CoreDirectivesModule {}
